<template>
	<b-navbar-nav class="d-md-down-none">
		<li class="nav-item px-3">
			<select
				class="form-control form-control-sm"
				size="0"
				style="display: inline-block;width: 170px;"
				v-model="$store.state.go_services_id"
				@change="$store.commit('set_go_services_id')"
			>
				<option value="0" :class="$store.state.go_services_id == 0 ? 'active' : ''">{{ $t('Services') }}</option>
				<option
					v-for="(x) in $store.state.go_services"
					:key="x.service_id"
					:value="x.service_id"
					:class="$store.state.go_services_id == x.service_id ? 'active' : ''"
				>{{ x.service_name }}</option>
			</select>
			<select
				class="form-control form-control-sm"
				size="0"
				style="display: inline-block;width: 170px;"
				v-model="$store.state.go_commands_id"
				@change="goTo"
			>
				<option value="0" :class="$store.state.go_commands_id == 0 ? 'active' : ''">{{ $t('Commands') }}</option>
				<option
					v-for="(x) in $store.state.go_commands"
					:key="x.command_id"
					:value="x.command_id"
					:class="$store.state.go_commands == x.command_id ? 'active' : ''"
				>{{ x.command_name }}</option>
			</select>
			<button
				@click="goTo"
				type="button"
				class="btn btn-sm btn-dark"
				style="text-transform: uppercase; display: inline-block"
			>
				<i class="fa fa-rocket"></i>
				{{ $t('go') }}
			</button>
		</li>
	</b-navbar-nav>
</template>
<script>
	export default {
		name: 'go-bar',

		data() {
			return {}
		},
		methods: {
			goTo() {
				if (parseInt(this.$store.state.go_commands_id) > 0) {
					this.$router.push({
						path:
							'/services/' +
							this.$store.state.go_services_id +
							'/commands/' +
							this.$store.state.go_commands_id,
					})
				} else if (parseInt(this.$store.state.go_services_id) > 0) {
					this.$router.push({
						path: '/services/' + this.$store.state.go_services_id + '/commands',
					})
				} else {
					this.$router.push({
						path: '/services',
					})
				}
			},
		},
		watch: {
			//
		},
		mounted() {
			//
		},
	}
</script>
